module.exports = __webpack_public_path__ + "img/finance8.492e5254.png";